import moment from "moment";

const task = {
  id: "",
  date: "",
  job: "",
  organization: "",
  employee: "",
  startTime: "",
  endTime: "",
  status: "",
  comment: "",
};

function useTasks() {
  const start = ({ job }) => moment(job.jobStartDate).valueOf();
  const end = ({ job }) => moment(job.jobEndDate).valueOf();

  const taskStatus = ({ task }) => task.status || "Unknown status";
  const findWeeks = ({ job }) => {
    const monday = moment(start({ job })).startOf("isoWeek");

    const dt = monday;
    const list = [];
    while (end({ job }) >= dt.valueOf()) {
      const from = monday.valueOf();
      const temp = monday.add(6, "days").valueOf();
      const to = temp >= end({ job }) ? end({ job }) : temp;

      list.push({
        from: from < start({ job }) ? start({ job }) : from,
        to,
      });
      monday.add(1, "days");
    }

    return list;
  };

  const findCurrentTaskSlots = ({ task }) => {
    const date = task.date;
    const employees = Array.isArray(task.employee)
      ? task.employee
      : [task.employee];

    const list = employees.map((emp) => {
      const from = moment(
        moment(date).format("DD/MM/YYYY") + task.startTime,
        "DD/MM/YYYY hh:mma"
      ).toDate();
      const to = moment(
        moment(date).format("DD/MM/YYYY") + task.startTime,
        "DD/MM/YYYY hh:mma"
      ).toDate();
      return {
        employee: emp,
        from,
        to,
      };
    });
    return list;
  };
  const findDays = ({ from, to, jobTasks, job }) => {
    const diff = moment(to).diff(from, "days");
    const list = [];
    let start = moment(from);
    const startDate = moment(job.jobStartDate);
    for (let i = 0; i <= diff; i++) {
      const dt = start.add(i === 0 ? 0 : 1, "day");
      const found = jobTasks?.find((i) => {
        return moment(i.date).valueOf() === dt.valueOf();
      });

      if (startDate.valueOf() > dt.valueOf()) {
      } else {
        if (found) list.push({ ...found, date: dt.valueOf(), occupied: true });
        if (!found) list.push({ ...task, date: dt.valueOf() });
      }
    }
    return list;
  };

  const availableDays = ({ job }) => {
    const weeks = findWeeks({ job });

    return weeks.map((dt) => {
      const diff = moment(dt.to).diff(dt.from, "days");

      const list = [];
      let start = moment(dt.from);
      const startDate = moment(job.jobStartDate);
      for (let i = 0; i <= diff; i++) {
        const dt = start.add(i === 0 ? 0 : 1, "day");
        const found = job.jobTasks.find((i) => {
          return moment(i.date).valueOf() === dt.valueOf();
        });

        if (startDate.valueOf() > dt.valueOf()) {
        } else {
          if (!found) list.push({ ...task, date: dt.valueOf() });
        }
      }
      return list;
    });
  };

  return {
    findWeeks,
    findDays,
    availableDays,
    taskStatus,
    findCurrentTaskSlots,
  };
}

export default useTasks;
